<template>
    <section class="datatable">
        <div class="row mb-2">
            <div class="col-12 col-md-6 mb-1 mb-md-0">
                <Input :class="classes" :placeholder="$t('datatable.search') + ' ' + name.toLowerCase()" v-model="search" @input="timerSearch()" small />
            </div>
            <div class="datatable-actions col-12 col-md-6 text-md-end" v-if="$slots.actions && !hideActions">
                <slot name="actions"></slot>
            </div>
        </div>
        <div class="datatable-filters">
            <slot name="filters"></slot>
        </div>
        <Card class="mt-2" noPadding>
            <div class="p-2 text-muted" v-if="loading">
                <Spinner /> {{ $t('datatable.loading') }}…
            </div>
            <div :class="scrollX ? 'table-wrapper' : ''" v-else>
                <Table class="mb-0" striped borderless :hover="hover">
                    <template v-slot:thead>
                        <slot name="thead"></slot>
                    </template>
                    <slot name="default"></slot>
                </Table>
            </div>
        </Card>
        <div class="d-md-flex mt-2" v-if="pagination && showPagination && !loading">
            <Pagination class="align-self-center" v-model="pagination" @input="fetchData" :showList="!!$slots.default" />
            <div v-if="$slots.default && pagination.total > 0" class="align-self-center ms-auto text-xxs text-muted mt-2 mt-md-0">
                {{ pagination.total | numeral }} {{ pagination.total > 1 ? $t('datatable.results') : $t('datatable.result') }}
            </div>
        </div>
    </section>
</template>

<script>
    import Pagination from '../Pagination'
    import Card from '../Card'
    import Table from '../Table'
    import Spinner from '../Loaders/Spinner'
    import Input from '../Form/Input'

    export default {
        name: 'Datatable',
        props: {
            name: String,
            loading: Boolean,
            pagination: Object,
            showPagination: {
                type: Boolean,
                default: true
            },
            hover: {
                type: Boolean,
                default: true
            },
            hideActions: Boolean,
            searchClass: [ String, Array ],
            scrollX: {
                type: Boolean,
                default: true
            }
        },
        components: {
            Card,
            Pagination,
            Table,
            Spinner,
            Input
        },
        data() {
            return {
                timingSearch: '',
                search: ''
            }
        },
        computed: {
            classes() {
                const defaultClasses = ['border']
                return [
                    ...defaultClasses,
                    ...(Array.isArray(this.searchClass) ? this.searchClass : [this.searchClass])
                ]
            }
        },
        methods: {
            timerSearch() {
                clearInterval(this.timingSearch);
                this.timingSearch = setInterval(this.makeSearch, 400);
            },
            makeSearch() {
                this.pagination.current_page = 1
                this.fetchData()
                clearInterval(this.timingSearch);
            },
            fetchData() {
                this.$emit('search', this.search);
            }
        }
    }
</script>

<style scoped>
    .table-wrapper {
        overflow-x: auto;
    }
    .datatable-actions,
    .datatable-filters {
        margin-top: -.4rem;
    }
    .datatable-actions > *,
    .datatable-filters > * {
        margin-top: .4rem;
        vertical-align: top;
    }
</style>